import PartneringWithSeveralBrands from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands";
import CostPerClickIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerClickIcon";
import CostPerLeadIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerLeadIcon";
import CostPerSaleIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerSaleIcon";
import RevenueShareIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/revenueShareIcon";
const list = [
    {
        title: "Cost-Per-Click (CPC)",
        p: "Ideal for building exposure and testing audiences. You only pay when someone clicks, so you can gauge interest before committing further.",
        icon: <CostPerClickIcon />,
    },
    {
        title: "Cost-Per-Lead (CPL)",
        p: "Ideal for building exposure and testing audiences. You only pay when someone clicks, so you can gauge interest before committing further.",
        icon: <CostPerSaleIcon />,
    },
    {
        title: "Cost-Per-Call",
        p: "Built for local businesses where phone inquiries drive revenue. You pay only for calls that meet an agreed duration or result in a real conversation.",
        icon: <CostPerLeadIcon />,
    },
    {
        title: "Custom & Blended Models",
        p: "Every business is different. If CPC, CPL, or cost-per-call doesn't fit your goals exactly, we'll build a model around what matters most, brand exposure, confirmed conversions, or your own pipeline priorities.",
        icon: <RevenueShareIcon />,
    },
];

export default function ThirdSection() {
    return (
        <section>
            <PartneringWithSeveralBrands
                list={list}
                mainTitle="Flexible Pricing Models for Every Business Need"
                benefitListClassName="lg:max-w-[1500px] lg:mx-auto"
                benefitItemClassName="lg:!w-[480px] 3xl:!w-[580px]"
            />
        </section>
    );
}
